/**
 * Convenience helper that filters out `false` values from an array. Useful
 * when setting config values that use the following pattern:
 *
 * ```ts
 * const config = [
 *   'foo',
 *   someCondition && 'bar',
 * ];
 * ```
 *
 * This ensures `config` will be typed as `string[]` instead of `(string | false)[]`.
 */
export function excludeFalse<T>(array: readonly (T | false)[]) {
  return array.filter(Boolean) as T[];
}
